import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]);

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-soft-pulse text-ink-soft font-manrope" data-testid="auth-loading">
          Loading your space…
        </div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={navState} replace />;
  }
  return children;
}
